/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scrollTop_1 = require("./scrollTop");
var timeout;
var killtimeout;
var targetPosition;
var DEFAULT_VELOCITY = 0.36;
var INTERVAL = 25;
var THRESHOLD = 5;
var KILL_ANIMATION_DELAY = 2500;
function clear() {
    clearTimeout(timeout);
    clearTimeout(killtimeout);
}
function loop(element, velocity) {
    if (velocity === void 0) { velocity = DEFAULT_VELOCITY; }
    var curr = scrollTop_1.scrollTop(element);
    if (Math.abs(curr - targetPosition) <= THRESHOLD) {
        scrollTop_1.scrollTop(element, targetPosition);
        return;
    }
    scrollTop_1.scrollTop(element, curr + (targetPosition - curr) * velocity);
    timeout = window.setTimeout(function () { return loop(element, velocity); }, INTERVAL);
}
function startLoop(element, target, offset, velocity) {
    if (offset === void 0) { offset = 0; }
    // eslint-disable-line max-statements
    clear();
    targetPosition =
        typeof target === "number"
            ? target
            : target.getBoundingClientRect().top + scrollTop_1.scrollTop(element);
    targetPosition += offset;
    if (targetPosition + window.innerHeight > document.body.clientHeight) {
        targetPosition = document.body.clientHeight - window.innerHeight;
    }
    if (targetPosition < 0) {
        targetPosition = 0;
    }
    loop(element, velocity);
    killtimeout = window.setTimeout(clear, KILL_ANIMATION_DELAY);
}
exports.scrollTopAnimated = function scrollTopAnimated(element, target, offset, velocity) {
    if (velocity === void 0) { velocity = DEFAULT_VELOCITY; }
    startLoop(element, target, offset, velocity);
};